import face from "../img/face.png";
import React from "react";
import {useInView} from "react-intersection-observer";

import reactLogo from "../img/logos/react.png";
import jsLogo from "../img/logos/js.png";
import nodeLogo from "../img/logos/nodejs.png";
import boostrapLogo from "../img/logos/bootstrap.png";
import tailwindLogo from "../img/logos/tailwind.png";
import threejsLogo from "../img/logos/threejs.png";
import typeScriptLogo from "../img/logos/Typescript.png";
import cssLogo from "../img/logos/css.png";
import html5Logo from "../img/logos/html5.png";
import gitLogo from "../img/logos/git.png";
import svelteLogo from "../img/logos/svelte.png";
import azureLogo from "../img/logos/azure.png";
import blenderLogo from "../img/logos/blender.png";
import figmaLogo from "../img/logos/figma.png";
import photoshopLogo from "../img/logos/photoshop.png";
import sqlLogo from "../img/logos/sql.png";
import logicproxLogo from "../img/logos/logicprox.png";
import unityLogo from "../img/logos/unity-black.png";
import csharpLogo from "../img/logos/csharp.png";
import dotnetLogo from "../img/logos/dotnet.png";

export default function Skills() {
	const skills = [
		{link: "https://svelte.dev/", name: "Svelte", image: svelteLogo},
		{link: "https://react.dev/", name: "React", image: reactLogo},
		{link: "https://getbootstrap.com/", name: "TypeScript", image: typeScriptLogo},
		{link: "https://azure.microsoft.com/", name: "Azure", image: azureLogo},
		{link: "https://tailwindcss.com/", name: "Tailwind", image: tailwindLogo},
		{link: "https://unity.com/", name: "Unity", image: unityLogo},
		{link: "https://dotnet.microsoft.com/en-us/", name: ".NET", image: dotnetLogo},
	];

	const otherSkills = [
		{link: "https://git-scm.com/", name: "Git", image: gitLogo},
		{link: "https://threejs.org/", name: "Three.js", image: threejsLogo},
		{link: "https://nodejs.org/en", name: "Node.js", image: nodeLogo},
		{link: "https://figma.com", name: "Figma", image: figmaLogo},
		{link: "https://blender.org/", name: "Blender", image: blenderLogo},
		{link: "https://www.adobe.com/no/products/photoshop.html", name: "Photoshop", image: photoshopLogo},
		{link: "https://www.apple.com/logic-pro/", name: "Logic Pro X", image: logicproxLogo},
		{link: "", name: "SQL", image: sqlLogo},

		{link: "https://learn.microsoft.com/en-us/dotnet/csharp/", name: "C#", image: csharpLogo},
	];

	const {ref: program, inView: programVisible} = useInView();
	const {ref: faceRef, inView: faceVisible} = useInView();

	return (
		<div className=" relative h-auto m-auto w-screen lg:h-screen text-white bg-neutral-900 overflow-hidden">
			<div
				className="hidden md:block top-52 left-0 absolute h-2/3 w-2/3 opacity-10 z-50 pointer-events-none"
				style={{
					background: "radial-gradient(circle, rgba(0,255,255,1) 0%, rgba(255,255,255,0) 50%, rgba(255,255,255,0) 100%)",
					filter: `hue-rotate(30deg) brightness(0.8)`,
				}}></div>
			<div className=" lg:scale-100 scale-75 flex flex-col m-auto md:h-screen md:flex-row">
				<div className=" sm:scale-100 scale-90 flex flex-col m-auto items-center">
					<div className=" flex gap-4">
						<h2 className=" text-white text-6xl font-extrabold text-center">My</h2>
						<h2
							style={{WebkitTextStrokeColor: "skyblue", WebkitTextStrokeWidth: "2px", WebkitTextFillColor: "rgba(0,0,0,0)"}}
							className=" text-6xl font-extrabold  h-max relative z-0 text-center">
							Skills
						</h2>
					</div>

					<div className="h-16"></div>
					<p className=" text-2xl italic max-w-md text-center">
						- Cooperative
						<br />- Hardworking
						<br />- Innovative
						<br /> - Creative
						<br />- Joyful
					</p>
					<div
						style={{
							height: "1px",
						}}
						className=" w-full bg-neutral-500 mt-8"></div>
					<div ref={program} className={`flex gap-5 m-auto mt-8 flex-wrap justify-center`}>
						{skills.map((skill, index) => (
							<a
								href={skill.link}
								target="_blank"
								key={index}
								style={{animationDelay: `${0.05 * (index + 1)}s`}}
								className={`${
									programVisible ? "slide-in" : ""
								} opacity-0 relative h-24 w-24 p-2 rounded-3xl flex flex-col gap-2 justify-center transition-all duration-200 bg-neutral-700 bg-opacity-50 hover:bg-neutral-600`}>
								<img className=" object-scale-down h-12 hover:grayscale-0" src={skill.image} alt={skill.name} />
								<p className=" text-center text-neutral-100 text-sm">{skill.name}</p>
							</a>
						))}
					</div>
					<h2 className=" text-neutral-100 text-2xl text-center mt-6">Other</h2>
					<div ref={program} className={`flex gap-3 m-auto mt-4 flex-wrap justify-center`}>
						{otherSkills.map((skill, index) => (
							<a
								href={skill.link}
								target="_blank"
								key={index}
								style={{animationDelay: `${0.05 * (index + 1)}s`}}
								className={`${
									programVisible ? "slide-in" : ""
								} opacity-0 relative w-16 h-16 p-2 rounded-xl flex flex-col gap-1 justify-center transition-all duration-200 bg-neutral-700 bg-opacity-50 hover:bg-neutral-600`}>
								<img className=" object-scale-down h-7 hover:grayscale-0" src={skill.image} alt={skill.name} />
								<p className=" text-center text-neutral-100 text-xs">{skill.name}</p>
							</a>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
